import { API } from "aws-amplify";
import { apiGateway } from "../../config";
import { store } from "../";
import {
  ADD_BLOCKS,
  ADD_PARTNER_SURVEYS,
  FETCHED_PARTNER_SURVEYS,
  FETCHING_BLOCKS,
  FETCHING_PARTNER_SURVEYS,
  REMOVE_PARTNER_INVITE,
  UPDATE_PARTNER_INVITE
} from "./constants";
import { getProjects } from "./projects";
import { getAccounts } from "./accounts";
import { getUser } from "./user";
const Gateway = apiGateway.find((gateway) => gateway.name === "client");

export const getBlocks = (override, project_id) => async (dispatch) => {
  if ((!store.getState().blocks.fetching && !store.getState().blocks.fetched) || override) {
    dispatch({ type: FETCHING_BLOCKS, payload: true });
    return API.get(Gateway.name, `/blocks/get-all/${(store.getState().session.account.account_id)}/${store.getState().authentication.user.cognito_id}`,
      {
        headers: {
          Authorization: store.getState().session.token
        }
      })
      .then((data) => {
        dispatch({ type: ADD_BLOCKS, payload: { list: data.payload, project_id } });
        dispatch({ type: FETCHING_BLOCKS, payload: false });
        return data;
      })
      .catch((error) => {
        dispatch({ type: ADD_BLOCKS, payload: { list: [], project_id } });
        dispatch({ type: FETCHING_BLOCKS, payload: false });
        return {
          success: false,
          message: error.response && error.response.data ? error.response.data.message : "Something went wrong."
        };
      });
  } else {
    dispatch({ type: ADD_BLOCKS, payload: { list: [], project_id } });
    return { success: true, payload: store.getState().blocks.list };
  }
};

export const getPartnerSurveys = async (override) => {
  if ((!store.getState().partners.fetchingPartnerSurveys && !store.getState().partners.fetchedPartnerSurveys) || override) {
  store.dispatch({ type: FETCHING_PARTNER_SURVEYS, payload: true });
  return API.get(Gateway.name, `/blocks/get-partner-surveys/${store.getState().session.account.account_id}/${store.getState().authentication.user.cognito_id}`,
    {
      headers: {
        Authorization: store.getState().session.token
      }
    })
    .then((data) => {
      store.dispatch({ type: FETCHING_PARTNER_SURVEYS, payload: false });
      store.dispatch({ type: FETCHED_PARTNER_SURVEYS, payload: new Date() });
      store.dispatch({ type: ADD_PARTNER_SURVEYS, payload: data.payload });
      return data;
    })
    .catch((error) => {
      store.dispatch({ type: FETCHING_PARTNER_SURVEYS, payload: false });
      store.dispatch({ type: FETCHED_PARTNER_SURVEYS, payload: new Date() });
      return {
        success: false,
        message: error.response && error.response.data ? error.response.data.message : "Something went wrong."
      };
    });
  } else {
    store.dispatch({ type: ADD_PARTNER_SURVEYS, payload: [] });
    return { success: true, payload: store.getState().blocks.list };
  }
};

export const submitIntakeSurvey = async (data, referral_base) => {
  return API.post(Gateway.name, `/partners/submit-intake/${store.getState().session.account.account_id}/${store.getState().authentication.user.cognito_id}`,
    {
      headers: {
        Authorization: store.getState().session.token
      },
      body: {
        data,
        referral_base
      }
    })
    .then((response) => {
      store.dispatch({ type: UPDATE_PARTNER_INVITE, payload: response.payload });
      return response;
    })
    .catch((error) => {
      return {
        success: false,
        message: error.response && error.response.data ? error.response.data.message : "Something went wrong."
      };
    });
};

export const updateIntakeSurvey = async (inviteId, data) => {
  return API.put(Gateway.name, `/partners/update-invite/${store.getState().session.account.account_id}/${store.getState().authentication.user.cognito_id}/${inviteId}`,
    {
      headers: {
        Authorization: store.getState().session.token
      },
      body: {
        data
      }
    })
    .then((response) => {
      store.dispatch({ type: UPDATE_PARTNER_INVITE, payload: response.payload });
      return response;
    })
    .catch((error) => {
      return {
        success: false,
        message: error.response && error.response.data ? error.response.data.message : "Something went wrong."
      };
    });
};

export const deleteIntakeSurvey = async (id) => {
  return API.del(Gateway.name, `/partners/delete-invite/${id}/${store.getState().session.account.account_id}/${store.getState().authentication.user.cognito_id}`,
    {
      headers: {
        Authorization: store.getState().session.token
      }
    })
    .then((response) => {
      store.dispatch({ type: REMOVE_PARTNER_INVITE, payload: response.payload });
      return response;
    })
    .catch((error) => {
      return {
        success: false,
        message: error.response && error.response.data ? error.response.data.message : "Something went wrong."
      };
    });
};

export const convertIntakeToPlan = async (inviteId) => {
  return API.post(Gateway.name, `/partners/convert-intake/${store.getState().session.account.account_id}/${store.getState().authentication.user.cognito_id}`,
    {
      headers: {
        Authorization: store.getState().session.token
      },
      body: {
        invite_id: inviteId
      }
    })
    .then(async (response) => {
      store.dispatch({ type: UPDATE_PARTNER_INVITE, payload: response.payload.invite });
      await getUser(store.getState().authentication.user.cognito_id, store.getState().session.account.account_id, true);
      store.dispatch(getAccounts(store.getState().authentication.user.cognito_id, store.getState().session.account.account_id, true));
      store.dispatch(getProjects(true));
      return response;
    })
    .catch((error) => {
      return {
        success: false,
        message: error.response && error.response.data ? error.response.data.message : "Something went wrong."
      };
    });
};